import React, { useEffect, useState } from 'react'
import Navigation from './navigation/navigation'
import { HoldCoPage } from './HoldCoPage'

export function Admin () {
  const [loading, setLoading] = useState(false)
  const [header, setHeader] = useState('EPC')
  const handleLogout = () => {
    localStorage.removeItem('jwt')
    localStorage.removeItem('userFirstName')
    localStorage.removeItem('userLastName')
    localStorage.removeItem('userEmail')
    localStorage.removeItem('token')
    window.location.reload()
  }
  const renderData = data => {
    if (data === 'HoldCo') {
      return <div>blank</div>
    } else {
      return <HoldCoPage />
    }
  }
  return (
    <>
      <Navigation
        appBarHeader={header}
        handleLogout={handleLogout}
        clicked={header => setHeader(header)}
      >
        {renderData(header)}
      </Navigation>
    </>
  )
}
